import { useEffect } from "react";
import { handleDecodeJSON } from "../utils/encodeDecodeJson";

const useFetchCandidateTokenDetails = ({ setCandidateTokenDetails }) => {
  useEffect(() => {
    async function fetchData() {
      const cookiesData = sessionStorage.getItem("candidate_exam_details");
      if (cookiesData) {
        const candidateTokenDetails = await handleDecodeJSON({
          decodeJSON: JSON.parse(cookiesData),
        });
        setCandidateTokenDetails(candidateTokenDetails);
      }
    }
    fetchData();
    window.addEventListener("storageUpdate", fetchData);
    return () => {
      window.removeEventListener("storageUpdate", fetchData);
    };
  }, []);
};

export default useFetchCandidateTokenDetails;
